import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentadditionaolinfo";

export default function AditionalEssayForProfile({ slug }) {
  const [infodb, setInfoDb] = useState([]);
  const [instructorNote, setInstructorNote] = useState("");
  const [studentNote, setStudentsNote] = useState("");
  const [detail, setDetail] = useState("");

  async function getDatafromMainEssay() {
    const data = await getStudentIdData(slug);
    setStudentsNote(data[0].studentNote);
    setInstructorNote(data[0].instructorNote);
    setDetail(data[0].detail);
    console.log("Additional İnfo: ", data);
    setInfoDb(data);
  }

  useEffect(() => {
    getDatafromMainEssay();
  }, [setInfoDb]);

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <h4 className="goal_settings_title"> Additional Info</h4>
          <div className="wishlist-item mt-5">
            <div style={{ color: "black", backgroundColor: "white" }}>
              <div className="mb-3">
                <label className="form-label fw-bold">Instructor Note:</label>
                <div>{instructorNote}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Student Note:</label>
                <div>{studentNote}</div>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">
                  Detail:
                </label>
                <div
                  style={{ lineHeight: "1.6", marginTop: "10px" }}
                  dangerouslySetInnerHTML={{ __html: detail }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
